{
  "agent_name": "{{brand}} 管理程式",
  "crumbs": "目前位置",
  "common": {
    "cancel": "取消",
    "details": "詳細",
    "loading": "讀取中",
    "retry": "重試",
    "saving": "儲存中…"
  },
  "nav": {
    "group": "IT 監控",
    "incidents": "事故",
    "unhandled_n": "{{n}} 件事故還沒有人處理",
    "hosts": "主機",
    "network": "網路與應用",
    "remote": "遠端協助"
  },
  "sev": {
    "P1": "緊急",
    "P2": "重要",
    "P3": "一般"
  },
  "home": {
    "bad": "異常",
    "attention": "注意",
    "ok": "正常",
    "unreadable": "讀不到",
    "unset": "未設定",
    "maintenance": "維護中",
    "maintenance_until": "維護中 · 到 {{time}}",
    "off_hours": "營業時段外",
    "baselining": "建立基準中（不影響狀態）"
  },
  "now": {
    "ongoing_for": "進行中 · {{n}} 分鐘",
    "recovered_at": "已恢復 {{time}}"
  },
  "handling": {
    "open": "未處理",
    "open_recovered": "未處理（還沒人看）",
    "acknowledged_by": "{{name}}已看到",
    "claimed_by": "{{name}}處理中",
    "mine": "你處理中",
    "since": " · {{time}} 起",
    "resolved": "已結案"
  },
  "person": {
    "you": "你",
    "someone": "有人",
    "system": "系統"
  },
  "impact": {
    "not_recording": "{{n}} 支攝影機沒有錄影 · 已 {{min}} 分鐘",
    "gap": "缺錄 {{n}} 支 × {{min}} 分鐘（無法補回）",
    "fine": "錄影不受影響",
    "fine_note": "錄影不受影響：{{note}}",
    "unknown": "錄影狀態讀不到",
    "unknown_note": "錄影狀態讀不到：{{note}}"
  },
  "incident": {
    "affected_n": "影響 {{n}} 台",
    "recurring": "反覆發生 · {{n}} 次",
    "for_min": "已 {{n}} 分鐘",
    "silenced_until": "靜默到 {{time}} · {{name}}",
    "alarms_open": "同$t(translation:leaf.cur)有警報 {{n}}",
    "impact": "影響",
    "see_gap": "看缺錄前後",
    "alarm_xref": "同$t(translation:leaf.cur)有 {{n}} 則還沒處理的警報",
    "see_alarms": "看警報",
    "affected_title": "受影響設備（{{n}}）",
    "affected_all": "全部 {{n}} 台",
    "col_kind": "種類",
    "col_name": "名稱",
    "col_state": "狀態",
    "timeline": "時間軸",
    "people": "這件事的人",
    "handler": "處理人",
    "seen_by": "看過",
    "resolved_by": "結案",
    "escalation": "升級",
    "nobody": "還沒有",
    "not_found": "這個事故找不到了",
    "not_found_body": "可能超過保存期限（13 個月），或你已經沒有這個$t(translation:leaf.cur)的權限。",
    "not_found_crumb": "找不到",
    "back_list": "回事故清單",
    "unavailable": "讀不到這個事故",
    "abar": "事故動作",
    "notified": "已通知"
  },
  "target": {
    "camera": "攝影機",
    "recorder": "錄影主機",
    "host": "主機",
    "network_device": "網路設備",
    "probe": "應用探針",
    "kinio_device": "設備"
  },
  "target_state": {
    "not_recording": "沒有錄影",
    "offline": "離線",
    "unreadable": "讀不到",
    "recovered": "已恢復",
    "ok": "正常",
    "service_stopped": "服務停了",
    "on_battery": "用電池中"
  },
  "ev": {
    "system": "系統",
    "bad": "異常",
    "person": "人的動作",
    "recover": "恢復",
    "notify": "通知"
  },
  "ev_person": {
    "open": "{{name}}：重新打開",
    "acknowledged": "{{name}}：已看到",
    "claimed": "{{name}}：我來處理",
    "resolved": "{{name}}：結案",
    "assigned": "{{name}}：交給 {{to}}"
  },
  "act": {
    "claim": "我來處理",
    "take_over": "換我處理",
    "acknowledge": "已看到",
    "resolve": "標成已解決…",
    "close": "結案…"
  },
  "resolve": {
    "title": "結案這件事故",
    "body": "結案後不再升級與提醒；30 分鐘內同一原因再發生會回到這件事故。",
    "note": "處理說明（選填）",
    "ok": "結案"
  },
  "conflict": {
    "handled_by": "已由 {{name}} 處理，畫面已更新",
    "changed": "這件事故的狀態剛被別人改了，畫面已更新",
    "next": "你按的動作沒有送出。要接手請按〔換我處理〕。"
  },
  "filter": {
    "all": "全部",
    "unclaimed": "沒人認領",
    "mine": "我處理的",
    "org": "組織",
    "org_label": "組織：{{label}}",
    "org_all": "全部組織",
    "org_n": "{{n}} 個組織",
    "org_unnamed": "客戶組織",
    "org_clear": "清除組織篩選",
    "org_max": "最多選 {{n}} 個組織"
  },
  "overview": {
    "it_blocks": "IT 監控",
    "incidents_title": "現在要處理的事故",
    "sev_n_P1": "緊急 {{n}}",
    "sev_n_P2": "重要 {{n}}",
    "sev_n_P3": "一般 {{n}}",
    "filter": "篩選事故",
    "see_all": "看全部 {{n}} 件",
    "none_watching": "目前沒有要處理的事 · 看管中 {{homes}} 個$t(translation:leaf.cur)",
    "none_filtered": "沒有符合的事故",
    "incidents_unavailable": "讀不到事故清單；其他區塊照常。",
    "homes_title": "$t(translation:leaf.cur)狀態",
    "homes_n": "{{n}} 個$t(translation:leaf.cur)",
    "homes_counts": "各狀態的$t(translation:leaf.cur)數",
    "homes_unavailable": "讀不到$t(translation:leaf.cur)狀態；其他區塊照常。",
    "others_ok": "其餘 {{n}} 個正常",
    "homes_more": "另有 {{n}} 個，到事故清單看全部",
    "none_watching_hosts": "目前沒有要處理的事 · 看管中 {{homes}} 個$t(translation:leaf.cur)、{{hosts}} 台電腦",
    "orgs_homes_n": "{{orgs}} 個組織 · {{n}} 個$t(translation:leaf.cur)",
    "org_p1_unclaimed": "沒人認領的緊急 {{n}}",
    "org_bad_homes": "異常 {{n}} 個$t(translation:leaf.cur)",
    "org_unreadable_homes": "讀不到 {{n}} 個$t(translation:leaf.cur)",
    "org_open": "未結事故 {{n}}",
    "org_hosts_offline": "離線主機 {{n}}",
    "orgs_others_ok": "其餘 {{n}} 個組織正常",
    "orgs_more": "另有 {{n}} 個組織，到事故清單看全部"
  },
  "live": {
    "on_s": "即時 · {{n}} 秒前更新",
    "on_m": "即時 · {{n}} 分鐘前更新",
    "off": "已中斷 · 最後更新 {{time}}",
    "stale_bar": "更新中斷 {{n}} 分鐘：下面是 {{time}} 的狀態，可能已經有新事故。",
    "reconnect": "重新連線"
  },
  "incidents": {
    "tabs": "事故分頁",
    "tab_open": "未結",
    "tab_open_n": "未結（{{n}}）",
    "tab_all": "全部",
    "none_open": "目前沒有未結的事故",
    "none": "還沒有事故",
    "none_filtered": "沒有符合的事故",
    "clear_filter": "清除篩選",
    "see_all": "看全部事故",
    "load_more": "再載入",
    "shown_all": "已顯示全部 {{n}} 件",
    "unavailable": "讀不到事故清單"
  },
  "enable_card": {
    "title": "用 {{console}} 看管 {{org}} 的網路與電腦",
    "body": "交換器斷線、伺服器停了、硬碟快壞，會先告訴你是哪個$t(translation:leaf.cur)、錄影有沒有受影響、可能原因與建議。只顯示要處理的事，不會一直響。",
    "note": "電腦上要裝「{{agent}}」，只回報健康資訊，不看畫面、檔案與輸入。啟用要由 {{org}} 的負責人接受資料處理協議。",
    "start": "開始",
    "later": "之後再說"
  },
  "org": {
    "title": "IT 監控",
    "crumb_org": "組織設定",
    "enable_title": "啟用 IT 監控",
    "enable_crumb": "啟用",
    "tabs": "IT 監控分頁",
    "tab_status": "啟用",
    "tab_oncall": "輪值表",
    "tab_keys": "管理員 passkey",
    "no_admin": "只有組織擁有者或組織管理員能設定 IT 監控。",
    "dpa": "資料處理協議",
    "dpa_accepted": "已接受 {{v}} 版（{{time}}）",
    "dpa_none": "還沒接受",
    "homes": "看管的$t(translation:leaf.cur)",
    "homes_none": "還沒有",
    "home_settings": "監控設定",
    "start_wizard": "開始啟用",
    "open_wizard": "加$t(translation:leaf.cur)或建佈署權杖",
    "manage": "設定",
    "card_enabled": "看管中 {{n}} 個$t(translation:leaf.cur) · 輪值表與啟用在這裡設定",
    "card_none": "還沒啟用。用它看管$t(translation:leaf.cur)的網路與電腦。",
    "tab_templates": "監控範本",
    "tab_handover": "接手",
    "tab_built": "代建的客戶"
  },
  "keys": {
    "intro": "每台電腦的管理程式只認這份清單上的簽章用 passkey 簽的安全政策。新增要清單上的一把在簽章頁確認；移除不用簽，但組織之前建的佈署權杖會全部失效。",
    "unavailable": "讀不到管理員清單（{{detail}}）。",
    "current": "目前清單（第 {{v}} 版）",
    "empty": "清單是空的：還沒有人能簽安全政策。加入的第一把不用簽，之後建的佈署權杖才帶新清單。",
    "you": "你",
    "stale": "帳號或 passkey 已經不在，請移除",
    "remove_replaced": "移除（換了手機或電腦）",
    "remove_lost": "移除（遺失或被偷）",
    "confirm_title": "移除 {{who}} 的 passkey {{id}}",
    "confirm_tokens": "移除後，組織之前建的 {{n}} 把佈署權杖會失效（已報到的電腦不受影響）：",
    "confirm_no_tokens": "沒有會失效的佈署權杖。",
    "token_line": "{{name}} · 還有 {{n}} 台沒報到",
    "confirm_remove": "立即移除（{{n}} 把權杖會失效）",
    "candidates": "可以加入的簽章用 passkey",
    "no_candidates": "沒有。組織擁有者或管理員在啟用精靈 ⓪ 建立簽章用 passkey 之後會出現在這裡。",
    "add_anchor": "加入",
    "add_sign": "加入（用我的 passkey 簽）",
    "need_listed": "要清單上已有的管理員替你加入；你自己的簽章用 passkey 還不在清單上。",
    "reinstall_title": "{{n}} 台電腦的管理員清單無法更新",
    "reinstall_body": "清單曾被清空後重新設定，這些電腦照安全規則不接受新的清單，遠端協助與要簽章的自動處置會被拒。用新的佈署權杖在這些電腦重新安裝管理程式（新權杖帶目前的清單），重裝後舊的那筆會被取代。",
    "reinstall_reanchor": "電腦上是 v{{v}} 的清單，之後經過重新設定",
    "reinstall_rejected": "電腦拒收新清單（{{code}}）",
    "reinstall_token": "建新的佈署權杖",
    "reinstall_token_home": "建新的佈署權杖 · {{home}}"
  },
  "wizard": {
    "steps": "啟用步驟",
    "done_sr": "（已完成）",
    "step_0": "passkey",
    "step_1": "資料處理協議",
    "step_2": "選$t(translation:leaf.cur)",
    "step_5": "佈署權杖",
    "title_0": "先確認你有 passkey",
    "title_1": "IT 監控資料處理協議",
    "title_2": "選要看管的$t(translation:leaf.cur)",
    "title_5": "建立佈署權杖",
    "next_0": "下一步：資料處理協議",
    "next_1": "下一步：選$t(translation:leaf.cur)",
    "next_5": "完成",
    "prev": "上一步",
    "skip": "略過這一步",
    "save_leave": "儲存並離開",
    "skip_finish": "略過，之後再建",
    "finish": "完成，回 IT 監控",
    "progress": "設定進度 {{n}} / {{total}}",
    "progress_note": "每一步都可以先略過，之後在「組織設定 › IT 監控」接著做。",
    "denied": "只有組織擁有者或組織管理員能啟用",
    "denied_body": "請 {{org}} 的擁有者或組織管理員啟用。",
    "status_unavailable": "讀不到 IT 監控的狀態（{{detail}}）。",
    "passkey_ok": "你已經有 {{n}} 把簽章用 passkey。",
    "passkey_need": "改電腦的管理員清單、簽安全政策都要用簽章用 passkey（在獨立的簽章頁建立，跟登入用的 passkey 分開；驗證碼不算）。",
    "passkey_readonly": "還沒註冊 passkey 前，IT 監控的安全設定對你是唯讀的。",
    "passkey_add": "建立簽章用 passkey",
    "passkey_no_sign": "這個環境還沒開簽章頁，暫時不能建立簽章用 passkey。",
    "passkey_sign_note": "會開一個新視窗（簽章頁），在那裡確認。",
    "passkey_name": "IT 監控",
    "passkey_unsupported": "這個瀏覽器不支援 passkey；請換一個瀏覽器或在手機上註冊。",
    "passkey_err": "沒有註冊成功（{{code}}）。",
    "dpa_version": "版本 {{v}}",
    "dpa_summary": "摘要",
    "dpa_s1": "{{org}} 是資料的控制者；服務供應商是受託者。",
    "dpa_s2": "收集電腦與網路設備的健康資訊（CPU、記憶體、磁碟、服務是否在跑、流量總量），不收畫面、檔案內容、按鍵內容。",
    "dpa_s3": "保存：指標 24 個月（彙總）、事故 13 個月、稽核至少 1 年；終止後 30 天刪除。",
    "dpa_full": "看全文",
    "dpa_accept": "我代表 {{org}} 接受 IT 監控資料處理協議（{{v}} 版）",
    "dpa_accepted": "已接受 {{v}} 版（{{time}}）。",
    "dpa_updated": "協議剛更新為 {{v}} 版，請重新看過再接受。",
    "before_dpa": "沒接受前能做什麼",
    "before_dpa_body": "可以先選$t(translation:leaf.cur)、建佈署權杖、把「{{agent}}」裝到電腦；電腦會等協議接受後才開始回報，不用重裝。",
    "need_dpa": "要先接受資料處理協議才能啟用$t(translation:leaf.cur)。",
    "to_dpa": "去接受協議",
    "homes_intro": "選了的$t(translation:leaf.cur)開始看管；開了 IT 監控的$t(translation:leaf.cur)，設備斷線、錄影中斷改由事故通知（同一件事只通知一次）。",
    "homes_none": "這個組織還沒有$t(translation:leaf.cur)。",
    "home_enabled": "已啟用",
    "enable": "啟用 {{n}} 個$t(translation:leaf.cur)",
    "need_homes": "要先啟用至少一個$t(translation:leaf.cur)才能建佈署權杖。",
    "to_homes": "去選$t(translation:leaf.cur)",
    "token_side": "建立權杖要再確認一次身分；權杖只會顯示一次。"
  },
  "token": {
    "name": "名稱",
    "home": "報到到哪個$t(translation:leaf.cur)",
    "default_name": "{{home}} 第一批",
    "expiry": "有效期限",
    "days": "{{n}} 天（到 {{until}}）",
    "expiry_hint": "最長 30 天。過期後還沒裝的電腦要用新權杖。",
    "max": "最多幾台（必填）",
    "max_hint": "超過授權台數的電腦會先是未授權，買了之後依報到順序轉正。",
    "max_bad": "請填 1 到 10000 的整數。",
    "cidrs": "只允許從這些網路報到（選填）",
    "cidrs_hint": "在別的網路裝的電腦會被擋下，回到公司網路後自動重試。",
    "cidrs_bad": "這些不是網段：{{list}}",
    "ownership": "這批電腦歸誰",
    "own_org": "組織擁有",
    "own_byod": "員工自有",
    "ownership_hint": "之後在主機頁可以逐台改。",
    "expected": "預期清單（選填）",
    "expected_hint": "匯入 CSV 或 AD 匯出的電腦名稱；報到進度會列出還沒報到的電腦。",
    "expected_n": "已讀到 {{n}} 台電腦名稱。",
    "once_note": "建立前會再確認一次身分；權杖只會顯示一次。",
    "create": "確認身分並建立",
    "new": "建立佈署權杖…",
    "new_title": "建立佈署權杖",
    "once_title": "只會顯示這一次",
    "once_body": "離開這一頁就看不到了。請複製到安裝設定裡，或下載成檔案。",
    "copy": "複製權杖",
    "copied": "已複製",
    "download": "下載權杖檔",
    "once_meta": "{{name}} · {{home}} · 最多 {{n}} 台 · 到 {{until}}",
    "install_title": "安裝「{{agent}}」",
    "install_1": "在要看管的電腦安裝「{{agent}}」。",
    "install_2": "把權杖檔放到那台電腦（只給系統管理員讀），安裝時指定這個檔案；權杖不要寫在指令列。",
    "install_3": "裝好後「{{agent}}」會自動報到；在那台電腦打開「{{agent}}」可以看收了什麼。",
    "install_note": "權杖不要放在大家都讀得到的共用資料夾：等於把權杖交給所有看得到的人。",
    "after_title": "裝好之後",
    "after_body": "到報到進度即時看每台的狀態與失敗原因。",
    "see_progress": "看報到進度",
    "state_active": "有效",
    "state_expired": "已過期",
    "state_exhausted": "已用完",
    "state_revoked": "已失效",
    "col_state": "狀態",
    "col_progress": "報到",
    "col_expires": "到期",
    "progress_short": "已報到 {{a}} / {{n}} · 失敗 {{f}}",
    "list_unavailable": "讀不到佈署權杖",
    "none": "還沒有佈署權杖",
    "none_body": "建一把權杖，在電腦安裝時帶上它，電腦就會報到到這個$t(translation:leaf.cur)。",
    "unavailable": "讀不到這把權杖",
    "revoke_btn": "撤銷…",
    "revoke_title": "撤銷「{{name}}」",
    "revoke_body": "撤銷後還沒報到的 {{n}} 台會報到失敗；已經報到的電腦不受影響。",
    "revoke": "撤銷權杖",
    "revoked_manual": "這把權杖已手動撤銷（{{time}}）；還沒報到的電腦要改用新權杖。",
    "revoked_admin_removed": "這把權杖已失效（{{time}}）：管理員清單有人被移除。請建新的權杖，換掉安裝設定裡的舊權杖。",
    "revoked_creator_left": "這把權杖已失效（{{time}}）：建立者已離開組織。請建新的權杖，換掉安裝設定裡的舊權杖。",
    "revoked_rebuilt": "這把權杖已被新的取代（{{time}}）。",
    "expired_bar": "這把權杖已在 {{time}} 過期；還沒裝的電腦要用新權杖。",
    "kpi_approved": "已報到",
    "kpi_failed": "失敗",
    "kpi_remaining": "還沒報到",
    "kpi_remaining_note": "沒送出報到的電腦雲端看不到",
    "failed_title": "失敗（{{n}}）",
    "col_host": "電腦",
    "col_reason": "原因與你能做什麼",
    "col_os": "作業系統",
    "col_ip": "來源 IP",
    "col_time": "時間",
    "failed": "失敗",
    "notyet_title": "還沒報到（{{n}}）",
    "notyet_expected": "對照預期清單還沒報到：{{list}}{{more}}",
    "and_more": " 等 {{n}} 台",
    "notyet_hint": "超過 1 小時沒消息的電腦可能沒裝成功（安裝設定還沒套用、電腦沒開、被防毒擋下）；原因只在那台電腦上看得到。",
    "ok_title": "已報到（{{n}}）",
    "ok_none": "還沒有電腦報到。",
    "unexpected": "不在預期清單",
    "kpi_pending": "等你確認",
    "rebuild_btn": "重建…",
    "rebuild_title": "重建「{{name}}」",
    "rebuild": "確認身分並重建",
    "rebuild_body": "沿用原本的$t(translation:leaf.cur)、來源網路、歸屬與預期清單，綁目前的管理員清單；台數上限是還沒報到的 {{n}} 台。新權杖只會顯示一次，要換掉安裝設定（GPO 指令碼、Intune、RMM）裡的舊權杖。換掉之前，還沒報到的電腦會繼續用舊權杖重試、照樣失敗，事故台數增加屬正常；已經報到的電腦不受影響。",
    "rebuilt_note": "這是重建的新權杖：舊的那一把已經換掉。請把下面的安裝參數換進 GPO 指令碼、Intune 或 RMM。"
  },
  "enroll": {
    "todo_prefix": "你能做什麼：",
    "reason_expired": "權杖已過期",
    "todo_expired": "建一把新權杖，換掉安裝設定裡的舊權杖。",
    "reason_exhausted": "已達台數上限",
    "todo_exhausted": "建一把新權杖，或請管理員提高上限。",
    "reason_revoked": "權杖已失效",
    "todo_revoked": "請建立者或代管的安裝商建新的權杖，換掉安裝設定裡的舊權杖。",
    "reason_source": "來源網路不在允許範圍",
    "todo_source": "回公司網路後會自動重試；或在權杖加允許的網段。",
    "reason_dpa": "還沒接受資料處理協議",
    "todo_dpa": "接受協議後電腦每 15 分鐘自動重試，不用重裝。",
    "reason_clock": "電腦時間差太多",
    "todo_clock": "校正這台電腦的時間，校正後自動重試。",
    "reason_hw": "這台電腦的硬體識別對不上",
    "todo_hw": "可能是複製的系統映像；請在那台電腦重新安裝。",
    "reason_invalid": "權杖不對",
    "todo_invalid": "確認安裝設定裡的權杖是完整的一整串。",
    "reason_other": "報到失敗",
    "todo_other": "看詳細裡的錯誤碼，或在那台電腦打開管理程式看原因。",
    "reason_host_rejected": "已拒絕加入",
    "todo_host_rejected": "這台電腦之後用這把權杖報到都會被拒；確定要加入的話請重建權杖，再用新權杖重裝。"
  },
  "home_settings": {
    "title": "監控設定",
    "crumb_sites": "組織與場域",
    "tabs": "監控設定分頁",
    "tab_tokens": "佈署權杖",
    "tab_notify": "通知",
    "tokens_intro": "電腦安裝時帶佈署權杖，就會報到到這個$t(translation:leaf.cur)。",
    "not_found": "找不到這個$t(translation:leaf.cur)",
    "back_sites": "回組織與場域",
    "not_enabled": "這個$t(translation:leaf.cur)還沒開 IT 監控；權杖可以先建，電腦要等啟用後才開始回報。",
    "no_org": "這個$t(translation:leaf.cur)不屬於組織，沒有輪值表。",
    "unavailable": "讀不到監控設定",
    "tab_collectors": "收集器",
    "tab_thresholds": "門檻與等級",
    "tab_probes": "探針",
    "tab_windows": "維護與營業時段",
    "tab_site": "現場資訊"
  },
  "notify": {
    "schedule": "輪值表",
    "no_schedule": "不用輪值表",
    "no_schedule_hint": "沒選輪值表時，緊急事故送$t(translation:leaf.cur)擁有者與管理員。",
    "schedule_hint": "緊急事故 0 分送目前時段的值班者；空檔直接送值班主管。",
    "contact": "客戶聯絡人",
    "contact_default": "預設：組織擁有者 {{name}}",
    "contact_default_none": "預設：組織擁有者",
    "contact_hint": "值班者與值班主管都收不到時，緊急事故送這個人。",
    "channels": "通知管道：App 推播（緊急事故用時效性通知）與 Email；簡訊與語音不提供。",
    "save_note": "改通知設定要再確認一次身分，並會通知這個$t(translation:leaf.cur)所屬組織的擁有者與管理員。",
    "save": "儲存",
    "saved": "已儲存。",
    "edit_schedules": "編輯輪值表"
  },
  "oncall": {
    "intro": "$t(translation:leaf.cur)指定輪值表、不寫人名；每週一 00:00（輪值表時區）換下一位。",
    "new": "新增輪值表",
    "none": "還沒有輪值表",
    "none_body": "沒有輪值表時，緊急事故送$t(translation:leaf.cur)擁有者與管理員。",
    "unavailable": "讀不到輪值表",
    "name": "名稱",
    "now_on": "現在值班",
    "nobody_now": "沒有人值班 → 直接送 {{name}}",
    "supervisor": "值班主管",
    "supervisor_hint": "15 分鐘沒有人〔我來處理〕時送他；空檔也直接送他。",
    "used_by": "用在",
    "homes_n": "{{n}} 個$t(translation:leaf.cur)",
    "edit_title": "編輯輪值表",
    "not_found": "找不到這份輪值表",
    "back": "回輪值表",
    "tz": "時區",
    "rotation_start": "輪替起點",
    "rotation_start_hint": "這一天所在那週由名單第一位值班。",
    "slot_title": "時段與輪替",
    "slot_name": "時段名稱",
    "slot_default": "全天",
    "time": "時間",
    "start": "開始",
    "end": "結束",
    "time_hint": "開始與結束一樣 = 整天；結束早於開始 = 跨午夜。",
    "days": "星期",
    "gap": "其他時間沒有人值班：緊急事故直接送值班主管 {{name}}（不叫醒客戶）。",
    "rotation": "週次輪替名單",
    "rotation_empty": "還沒有人。至少加一位。",
    "this_week": "本週",
    "next_week": "下週",
    "up": "把 {{name}} 往前移",
    "down": "把 {{name}} 往後移",
    "remove": "從名單移除 {{name}}",
    "remove_short": "移除",
    "add_person": "加入輪替的人",
    "add": "加入",
    "pick": "選一位成員",
    "summary": "本週{{slot}}：{{now}} · 主管 {{sup}} · 下週：{{next}}",
    "summary_empty": "名單是空的：這段的緊急事故會直接送值班主管。",
    "save_note": "存檔要再確認一次身分；會通知指定這份輪值表的$t(translation:leaf.cur)所屬組織。",
    "save": "儲存輪值表",
    "err_name": "請填名稱",
    "err_supervisor": "請選值班主管",
    "err_days": "至少選一天",
    "err_time": "時間格式要是 時:分",
    "err_rotation": "輪替名單至少要有一位",
    "err_conflict": "這份輪值表剛被別人改過；請重新整理後再改。"
  },
  "day": {
    "1": "週一",
    "2": "週二",
    "3": "週三",
    "4": "週四",
    "5": "週五",
    "6": "週六",
    "7": "週日"
  },
  "err": {
    "default": "發生錯誤（{{code}}）。",
    "NETWORK": "連不上服務，請檢查網路後重試。",
    "NO_SESSION": "登入已過期，請重新登入。",
    "UNAUTHORIZED": "登入已過期，請重新登入。",
    "FORBIDDEN": "你沒有這個動作的權限。",
    "NOT_FOUND": "找不到，可能已經被刪除或你沒有權限。",
    "UNAVAILABLE": "服務暫時無法使用，請稍後再試。",
    "RATE_LIMITED": "太多次了，請稍後再試。",
    "REAUTH_REQUIRED": "要先確認身分才能做這個動作。",
    "PASSKEY_REQUIRED": "這個動作要用 passkey 確認；請先在「我的帳號 › 安全性」註冊 passkey。",
    "KMGR_REGION_UNSUPPORTED": "這個組織所在的地區不提供 IT 監控。",
    "KMGR_DPA_REQUIRED": "要先接受 IT 監控資料處理協議。",
    "INVALID_ARGUMENT": "資料不對，請檢查後重試。",
    "INVALID_TRANSITION": "這件事故目前的狀態不能這樣改。",
    "INCIDENT_STATE_CONFLICT": "這件事故的狀態剛被別人改了。",
    "CONFLICT": "剛被別人改過，請重新整理後再試。",
    "FEATURE_DISABLED": "這個環境還沒開這個功能。",
    "KMGR_STOPPED": "IT 監控已被組織暫停。",
    "HANDOVER_INCOMPLETE": "代建的組織還沒完成接手",
    "ORG_LIMIT": "組織數量已達上限"
  },
  "cause": {
    "service_stopped": "{{target}} 的 {{subject}} 停了",
    "host_offline": "{{target}} 離線",
    "other": "{{target}} 異常",
    "disk_full": "{{target}} 的 {{subject}} 磁碟快滿了",
    "power_outage": "停電",
    "ups_output_off": "{{target}} 輸出已斷",
    "ups_overload": "{{target}} 負載過高",
    "ups_battery": "{{target}} 電池需要處理",
    "poe_budget": "{{target}} PoE 供電超過門檻",
    "poe_denied": "{{target}} PoE 拒絕供電"
  },
  "home_reason": {
    "incidents": "{{n}} 件進行中的事故",
    "unreadable_since": "電腦都沒有回應 · 最後回報 {{time}}",
    "unreadable_never": "電腦還沒有回報過",
    "unset": "還沒有電腦報到",
    "watching": "看管 {{n}} 台電腦",
    "collector_offline": "收集器 {{name}} 離線 {{n}} 分鐘",
    "snmp_auth": "網路設備 SNMP 驗證失敗",
    "maintenance_by": "{{name}}設的維護"
  },
  "ev_text": {
    "opened": "開事故：{{cause}}",
    "recurred": "同一原因再發生，併回這件事故",
    "recovered": "已恢復",
    "auto_resolved": "已恢復 24 小時沒人處理，系統結案",
    "notify_opened": "推播給 {{who}}",
    "notify_resolved": "恢復通知（不響鈴）給 {{who}}",
    "home_admins": "$t(translation:leaf.cur)擁有者與管理員"
  },
  "dur": {
    "minutes": "{{n}} 分鐘",
    "hours": "{{n}} 小時",
    "days": "{{n}} 天"
  },
  "global_stop": {
    "title": "Kinio 已暫停所有自動處置與遠端協助（{{time}} 起）",
    "scope_all": "全部組織都受影響；監控、事故與通知照常。恢復由 Kinio 操作，這裡沒有恢復鈕。",
    "scope_org": "這個組織受影響；監控、事故與通知照常。恢復由 Kinio 操作。"
  },
  "host": {
    "online": "在線",
    "offline": "離線",
    "offline_for": "離線 {{for}}",
    "shutdown": "已關機 · {{time}}",
    "sleep": "睡眠中",
    "away": "不在現場 · {{for}}",
    "updating": "更新中 · {{n}} 分鐘",
    "suspended": "已停用（複製）",
    "revoked": "已撤銷",
    "unknown": "不知道",
    "unlicensed": "未授權",
    "is_collector": "收集器",
    "critical": "關鍵主機",
    "critical_hint": "離線或登記的服務停止算緊急（防抖 3 分鐘）。",
    "local_paused": "本機已暫停（{{by}} {{time}}）",
    "local_paused_bar": "這台電腦的使用者 {{by}} 在 {{time}} 暫停了自動處置與遠端協助（只影響這台）；監控照常。",
    "key_hw": "安全晶片",
    "key_sw": "沒有硬體保護",
    "metric_cpu": "CPU",
    "metric_mem": "記憶體",
    "metric_disk": "磁碟",
    "disk_mount": "磁碟 {{mount}}",
    "primary_user": "主要使用者 {{name}}",
    "not_found": "找不到這台電腦",
    "not_found_body": "可能已經移除，或你已經沒有這個$t(translation:leaf.cur)的權限。",
    "back_list": "回主機清單",
    "tabs": "主機分頁",
    "tab_overview": "概況",
    "tab_telemetry": "回報了什麼",
    "this_pc": "這台電腦",
    "class_seat": "{{cls}}（授權台數：{{cls}}）",
    "last_seen": "最後回報",
    "collector_scan": "可以掃的網段",
    "collector_none": "還沒有指定網段",
    "collector_error": "收集器回報錯誤：{{code}}",
    "settings_title": "這台的監控設定",
    "expected_offline": "預期離線時段",
    "expected_offline_hint": "時段內沒消息不開事故、不算離線；伺服器預設沒有。",
    "expected_offline_ws": "工作站預設：下班關機、睡眠不算離線，超過 7 天沒上線才列一般。另外可以加固定的時段。",
    "expected_offline_none": "沒有",
    "save_note": "改這台的設定會寫稽核。",
    "saved": "已儲存。",
    "primary_user_label": "主要使用者",
    "primary_user_hint": "用於搜尋與顯示（遠端協助的等待畫面也寫這個名字）。可選組織成員或直接打姓名，不收集登入帳號。",
    "primary_user_ph": "例如：王小明 · 會計部",
    "primary_user_member": "組織成員"
  },
  "hosts": {
    "tabs": "主機分頁",
    "tab_all": "全部",
    "tab_all_n": "全部（{{n}}）",
    "tab_enrolling": "報到中",
    "tab_unlicensed": "未授權",
    "tab_unlicensed_n": "未授權（{{n}}）",
    "filter_state": "狀態",
    "state_any": "狀態：全部",
    "state_online": "在線",
    "state_offline": "離線",
    "state_expected_offline": "預期離線",
    "state_suspended": "已停用",
    "state_revoked": "已撤銷",
    "filter_class": "類別",
    "class_any": "類別：全部",
    "only_issues": "有異常的",
    "unavailable": "讀不到主機清單",
    "none": "還沒有電腦報到",
    "none_body": "建佈署權杖、在電腦安裝管理程式後，電腦會出現在這裡。",
    "none_filtered": "沒有符合的電腦",
    "shown_all": "已顯示全部 {{n}} 台",
    "footnote": "數字只在異常時著色；「已關機 / 睡眠中 / 更新中 / 不在現場」是預期離線，不開事故。",
    "col_name": "名稱",
    "col_home": "$t(translation:leaf.cur)",
    "col_org_home": "組織 › $t(translation:leaf.cur)",
    "col_class": "類別",
    "col_state": "狀態",
    "col_metrics": "CPU · 記憶體 · 磁碟",
    "col_version": "管理程式版本",
    "col_key": "金鑰保護",
    "col_since": "報到時間",
    "col_actions": "動作",
    "enrolling_none": "沒有還在報到的權杖",
    "enrolling_none_body": "有效的佈署權杖都已用完或還沒建；建一把新的，電腦安裝時帶上它。",
    "unlicensed_none": "沒有未授權的電腦",
    "unlicensed_none_body": "授權台數夠用。",
    "unlicensed_bar": "{{n}} 台未授權：",
    "unlicensed_body": "只回報在線與基本資訊，不存指標、不發事故、不能遠端協助，本機規則也停。授權台數用完後後報到的先是未授權，不會把已在看管的踢掉。",
    "unlicensed_need_admin": "改派或加購授權要由組織擁有者或組織管理員處理。",
    "reason_released": "授權被改派給別台",
    "search": "搜尋名稱或主要使用者",
    "search_none": "沒有符合「{{q}}」的電腦"
  },
  "seat": {
    "server": "伺服器",
    "workstation": "工作站",
    "summary_title": "授權台數",
    "available_n": "還有 {{n}} 台可用",
    "all_used": "已全部使用",
    "buy": "加購…",
    "need_billing": "購買授權台數要帳單權限，請擁有者（{{name}}）處理。",
    "owner_role": "擁有者",
    "reassign_hint": "也可以把已授權的電腦（例如已離職的筆電）改派給這裡的電腦。",
    "reassign_btn": "改派授權…",
    "reassign_title": "把授權改派給 {{host}}",
    "reassign_body": "選一席給這台；原本持有那一席的電腦會變成未授權。",
    "pick": "選一席",
    "option_assigned": "{{host}}（{{time}} 起）",
    "option_free": "空的一席",
    "no_seats": "這個類別沒有席次。",
    "reassign_warn": "{{host}} 會變成未授權。",
    "reassign_ok": "改派"
  },
  "net": {
    "title": "網路與主機",
    "hosts_n": "{{n}} 台電腦",
    "unavailable": "讀不到主機與網路；其他區塊照常。",
    "unreadable": "讀不到網路設備",
    "unreadable_collector": "讀不到網路設備（收集器 {{name}} 離線 {{for}}）",
    "and_more": "，另 {{n}} 台",
    "unreadable_auth": "讀不到網路設備（SNMP 驗證失敗）",
    "unreadable_note": "交換器、AP 都沒算進數字",
    "see_collectors": "查看收集器",
    "collector_unnamed": "收集器",
    "row_network_down": "網路設備沒有回應（WAN / 交換器 / AP）",
    "row_servers_offline": "伺服器離線",
    "row_collectors_offline": "收集器離線",
    "row_devices_offline": "設備離線",
    "row_storage_faults": "錄影主機儲存異常",
    "row_recording_gaps": "攝影機有錄影缺口（24 小時）",
    "n_network_down": "{{n}} 台",
    "n_servers_offline": "{{n}} 台",
    "n_collectors_offline": "{{n}} 台",
    "n_devices_offline": "{{n}} 台",
    "n_storage_faults": "{{n}} 台",
    "n_recording_gaps": "{{n}} 支",
    "n": "{{n}}",
    "n_hosts": "{{n}} 台",
    "others_ok": "其餘 {{n}} 項正常",
    "all_ok": "{{n}} 項都正常",
    "hosts_line": "電腦：{{online}} 在線 · {{expected}} 預期離線",
    "todo_title": "設定待辦",
    "todo_note": "不是故障，不算進$t(translation:leaf.cur)狀態",
    "todo_unlicensed": "未授權的電腦",
    "tabs": "網路與應用分頁",
    "tab_devices": "網路設備",
    "tab_devices_n": "網路設備（{{n}}）",
    "tab_probes": "應用探針",
    "tab_probes_n": "應用探針（{{n}}）",
    "tab_collectors": "收集器",
    "tab_collectors_n": "收集器（{{n}}）",
    "no_homes": "目前範圍沒有看管中的$t(translation:leaf.cur)",
    "no_homes_body": "換個範圍，或先啟用 IT 監控。",
    "partial_failed": "{{n}} 個$t(translation:leaf.cur)讀不到；其他照常。",
    "col_name": "名稱",
    "col_addr": "位址",
    "col_method": "讀取方式",
    "col_ifs": "介面",
    "col_poe": "PoE",
    "col_temp": "溫度",
    "col_collector": "收集器",
    "col_target": "目標",
    "col_kind": "種類",
    "col_last": "最後檢查",
    "col_scan": "負責網段",
    "col_applied": "設定套用",
    "method_snmp": "SNMP 唯讀",
    "method_ping": "只用 ping",
    "ok_snmp": "可以讀取",
    "ok_snmp_n": "可以讀取 · {{n}} 個介面",
    "ok_ping": "有回應",
    "ok_probe": "正常",
    "bad_snmp": "讀取失敗（碼 {{code}}）",
    "bad_ping": "沒有回應",
    "bad_probe": "失敗（碼 {{code}}）",
    "unassigned": "沒有收集器負責",
    "noresult": "還沒有結果",
    "ifs_down": "{{n}}（{{down}} 個斷線）",
    "ifs_n": "{{n}} 個介面",
    "devices_note": "掃到的 Kinio 設備不列在這裡，在「設備」頁；介面、PoE、溫度要收集器讀得到才有。",
    "devices_none": "還沒有網路設備",
    "devices_none_body": "先指定一台電腦當收集器並給它網段，再加交換器、路由器、防火牆。",
    "probes_none": "還沒有應用探針",
    "probes_none_body": "用 HTTP / TCP / 檔案新鮮度探針看服務有沒有在跑。",
    "collectors_none": "還沒有收集器",
    "collectors_none_body": "收集器是$t(translation:leaf.cur)裡一台裝了管理程式的電腦，負責讀網路設備與跑探針。",
    "setup_collector": "設定收集器",
    "setup_probe": "新增探針",
    "applied_v": "已套用 v{{v}}",
    "pending_v": "待套用 v{{v}}（目前 v{{cur}}）",
    "row_disks_full": "磁碟快滿",
    "n_disks_full": "{{n}} 台",
    "by_org_title": "依組織",
    "org_net_down": "網路設備沒有回應 {{n}}",
    "org_unreadable": "讀不到網路設備",
    "org_servers_offline": "伺服器離線 {{n}}",
    "org_disks_full": "磁碟快滿 {{n}}",
    "org_collectors_offline": "收集器離線 {{n}}",
    "orgs_others_ok": "其餘 {{n}} 個組織正常",
    "orgs_more": "另有 {{n}} 個組織有狀況，從主機頁篩組織看",
    "row_ups_on_battery": "電源 · UPS 用電池中",
    "n_ups_on_battery": "{{n}} 台",
    "row_ups_unreadable": "電源 · UPS 讀不到",
    "n_ups_unreadable": "{{n}} 台",
    "row_poe_over_warn": "PoE 供電超過注意門檻",
    "n_poe_over_warn": "{{n}} 台",
    "todo_ups_no_downstream": "還沒登記下游的 UPS",
    "n_ups": "{{n}} 台",
    "org_ups_on_battery": "UPS 用電池中 {{n}}",
    "org_poe_over_warn": "PoE 超過門檻 {{n}}",
    "tab_ups": "不斷電系統（UPS）",
    "tab_ups_n": "不斷電系統（UPS）{{n}}"
  },
  "collector": {
    "intro": "收集器是這個$t(translation:leaf.cur)裡一台裝了管理程式的電腦：讀交換器、路由器、防火牆（SNMP 唯讀或 ping），跑應用探針。帳密只存在收集器，雲端看不到。",
    "policy_scan": "組織政策允許掃的網段：{{cidrs}}",
    "policy_none": "組織政策還沒允許任何網段：請組織管理員在「組織設定 › IT 監控 › 安全政策」設定。",
    "none": "還沒有收集器",
    "none_body": "選一台已上線的電腦當收集器。",
    "add_device": "新增網路設備…",
    "need_collector": "要先有收集器才能加網路設備。",
    "kinio_note": "掃到的 Kinio 設備（攝影機、Kinio Station）標「已是 Kinio 設備」並連到設備頁，不重複建立。",
    "title": "收集器",
    "scan": "可以掃的網段",
    "scan_hint": "每行一個網段（例 10.20.0.0/16）；要在組織政策允許的範圍內。",
    "saved": "已儲存，收集器上線時會套用。",
    "err_scan": "{{target}} 不在組織允許掃的網段內。",
    "save_scan": "儲存網段",
    "local_note": "收集器本機也要開（管理程式設定）；沒開時這裡會顯示錯誤。",
    "pick": "選哪台電腦",
    "make": "設成收集器"
  },
  "probe": {
    "intro": "探針由收集器定時檢查：HTTP（狀態碼、關鍵字、憑證到期）、TCP 埠、檔案新鮮度（排程有沒有跑）。不收回應內容。",
    "add": "新增探針…",
    "add_title": "新增探針",
    "edit": "修改…",
    "edit_title": "修改探針",
    "kind_ping": "ping",
    "kind_snmp": "SNMP",
    "kind_http": "HTTP",
    "kind_tcp": "TCP 埠",
    "kind_file": "檔案新鮮度",
    "host": "主機名稱或位址",
    "port": "埠",
    "scheme": "協定",
    "path": "路徑",
    "keyword": "關鍵字（選填）",
    "http_hint": "只比對狀態碼 200 與關鍵字、量延遲、看憑證到期；不跟轉址。",
    "file": "檔案路徑",
    "file_hint": "只看收集器上這個檔案（含網路路徑）的最後修改時間，不讀內容。",
    "credential": "帳密參照",
    "credential_hint": "SNMP 要用收集器上已有的帳密參照（帳密由管理員在收集器設定，雲端看不到）。",
    "interval": "檢查間隔",
    "every_s": "每 {{n}} 秒",
    "collector_auto": "自動（依網段）",
    "err_target": "請填目標位址",
    "err_port": "埠要是 1–65535",
    "err_path": "路徑要以 / 開頭",
    "err_file": "請填檔案路徑",
    "err_collector_offline": "收集器離線，無法測試；先確認收集器在線。",
    "err_collector_disabled": "收集器本機沒開收集功能。",
    "test": "測試連線",
    "test_ok": "可以連上",
    "tls_days": "憑證 {{n}} 天後到期",
    "test_timeout": "沒有回應（逾時）",
    "test_unreachable": "連不到",
    "test_auth_failed": "驗證失敗：使用者名稱或密碼不對",
    "test_credential_missing": "沒有帳密",
    "test_tls_error": "憑證有問題",
    "test_dns": "名稱解析失敗",
    "test_unexpected": "回應不符預期",
    "test_not_allowed": "目標不在允許範圍",
    "test_collector_error": "收集器錯誤",
    "test_failed": "失敗",
    "create": "建立",
    "delete": "刪除…",
    "delete_title": "刪除「{{name}}」",
    "delete_body": "它的檢查與事故一起解除。",
    "none_body": "新增一個探針看服務有沒有在跑。"
  },
  "threshold": {
    "intro": "每個條件的等級與防抖（連續多久才開事故）；改了只影響這個$t(translation:leaf.cur)。防抖只能比預設長；影響錄影的條件不能關。",
    "col_condition": "條件",
    "col_severity": "等級",
    "col_debounce": "防抖",
    "rule_home_unreachable": "$t(translation:leaf.cur)失聯",
    "rule_camera_not_recording": "攝影機沒有錄影",
    "rule_recorder_storage": "錄影主機硬碟故障或錄影空間 0",
    "rule_critical_host": "關鍵主機離線或服務停止",
    "rule_network_device": "交換器 / 路由器 / WAN 沒有回應",
    "rule_server_offline": "一般伺服器離線、服務停止；收集器離線",
    "rule_disk_tls_probe": "磁碟快滿、SMART 警告、TLS 到期、探針失敗",
    "rule_unreadable": "讀不到（收集器或管理程式失聯）",
    "rule_enroll_failed": "新電腦報到失敗",
    "rule_workstation_offline": "工作站離線超過期限",
    "changed": "已改",
    "immediate": "立即",
    "minutes": "{{n}} 分鐘",
    "no_incident": "不開事故",
    "disk_pct": "磁碟快滿（%）",
    "tls_days": "TLS 幾天內到期",
    "ws_days": "工作站離線幾天才列一般",
    "err_disk": "磁碟門檻要在 50–99",
    "err_tls": "TLS 天數要在 1–90",
    "err_ws": "工作站天數要在 7–90",
    "reset": "還原預設",
    "save_note": "改門檻會寫稽核。",
    "saved": "已儲存。",
    "updated": "{{name}} 於 {{time}} 修改"
  },
  "maint": {
    "title": "維護時段",
    "inactive": "現在不是維護中。",
    "set_by": "{{name}} {{time}} 設的",
    "active_note": "維護中不開事故、不推播、不自動處置；影響錄影的仍送現場通知。結束後仍異常的 5 分鐘後開事故。",
    "end": "結束維護",
    "quick_label": "一鍵維護",
    "extend_label": "延長",
    "hours_n": "{{n}} 小時",
    "start": "設成維護中 {{n}} 小時",
    "extend": "延長",
    "quick_note": "新設或延長要再確認一次身分，並通知這個$t(translation:leaf.cur)所屬組織的擁有者與管理員；結束不用。",
    "schedule": "排程維護",
    "schedule_none": "沒有排程。",
    "save_note": "新設或改排程要再確認一次身分並通知客戶。",
    "save_schedule": "儲存排程",
    "saved": "已儲存。",
    "saved_notified": "已儲存，已通知 {{n}} 人。",
    "unchanged": "沒有變更。"
  },
  "biz": {
    "title": "營業時段",
    "intro": "營業時段外攝影機與工作站的離線降一級（不是不通知）；狀態旁加 ☾。",
    "all_day": "全天營業（沒設時段）。",
    "save_note": "不用再確認身分；會寫稽核。",
    "saved": "已儲存。"
  },
  "window": {
    "days": "星期",
    "start": "開始",
    "end": "結束",
    "remove": "移除",
    "add": "加一段",
    "hint": "開始與結束一樣 = 整天；結束早於開始 = 跨午夜。",
    "err_days": "每段至少選一天",
    "err_time": "時間格式要是 時:分",
    "every_day": "每天",
    "all_day": "整天"
  },
  "site": {
    "title": "現場資訊",
    "intro": "事故頁最上面會顯示這些；每次修改寫稽核。",
    "edit": "編輯",
    "collapse": "收合",
    "expand": "展開",
    "customer": "客戶",
    "level_n": "服務等級 {{level}}",
    "until": "到 {{date}}",
    "level_note": "服務等級只顯示，不影響通知：緊急事故一律照輪值表推播。",
    "contact": "現場聯絡",
    "call": "撥打",
    "it_support": "IT 支援",
    "rack": "機櫃",
    "access": "門禁",
    "f_service_level": "服務等級",
    "f_contract_until": "合約到期",
    "f_contact_role": "聯絡人身分",
    "f_contact_name": "現場聯絡人",
    "f_contact_phone": "電話",
    "f_it_support": "IT 支援電話與時段",
    "f_rack_note": "機櫃說明",
    "f_access_note": "門禁說明",
    "h_service_level": "只顯示在事故頁，不影響通知。",
    "h_contact_phone": "事故頁可直接撥打。",
    "h_it_support": "員工求助畫面會顯示。",
    "ph_role": "大樓夜班保全",
    "ph_it": "02-2345-6789 · 週一至週五 08:30–18:00",
    "err_phone": "電話只能有數字、+、-、括號。",
    "save_note": "有「監控設定」權限的人能改；每次修改寫稽核。",
    "saved": "已儲存。",
    "preview": "預覽：事故頁"
  },
  "telemetry": {
    "intro": "「{{agent}}」只回報下面這些電腦健康資訊給 {{org}}，不看畫面、檔案與輸入。",
    "last_upload": "最近一次回報 {{time}}。",
    "item_cpu_mem_disk": "CPU / 記憶體 / 磁碟",
    "desc_cpu_mem_disk": "使用率、每個磁碟的用量與 SMART 狀態",
    "item_net_bytes": "網卡流量總量",
    "desc_net_bytes": "每個介面的上傳 / 下載總量；不收連線目的地",
    "item_uptime_power": "開機時間 · 電源狀態",
    "desc_uptime_power": "開機多久、關機 / 睡眠 / 更新重開",
    "item_services": "服務是否在跑",
    "desc_services": "只有管理程式發現並登記的服務名稱與狀態",
    "item_os_update": "系統更新",
    "desc_os_update": "有沒有待安裝的更新",
    "item_event_log": "系統事件記錄",
    "desc_event_log": "只送符合規則的片段，使用者名稱、Email 與 IP 已遮罩；預設不收登入名稱與安全事件",
    "never_title": "一律不收",
    "never_cmdline": "程式的命令列參數",
    "never_window_title": "視窗標題",
    "never_files": "開啟中的檔案名稱",
    "never_connections": "逐筆網路連線目的地",
    "never_images": "攝影機影像、縮圖、快照",
    "local_page": "要看這台實際送出的值：在那台電腦打開「{{agent}}」›〔看收了什麼〕。"
  },
  "remote": {
    "screen_person": "螢幕前的人",
    "your_org": "你的組織",
    "list_sep": "、",
    "dialog_title": "遠端協助 · {{host}}",
    "tabs": "遠端協助分頁",
    "tab_requests": "協助請求",
    "tab_requests_n": "協助請求（{{n}}）",
    "tab_records": "紀錄",
    "form_lead": "{{name}}會在電腦上看到你的名字與「{{org}}」，按〔允許〕才會開始。整段期間對方螢幕有紅框與浮動列，可以隨時結束。",
    "not_admin": "{{name}}不是這台電腦的管理員：遇到要管理員密碼的視窗（例如安裝驅動），你看不到也無法代按，需要現場有管理員帳號的人。",
    "perms_title": "要對方允許的權限",
    "perm": {
      "view": "看",
      "control": "控制",
      "clipboard": "剪貼簿",
      "file_transfer": "檔案傳輸"
    },
    "perm_hint": {
      "view": "看對方的畫面（一定有）",
      "control": "用滑鼠與鍵盤操作",
      "clipboard": "跟對方互相複製貼上文字",
      "file_transfer": "傳檔案給對方；對方也可以自己挑檔案傳給你"
    },
    "no_recording": "這次不錄影。",
    "no_recording_short": "不錄影",
    "reason": "理由（寫進紀錄，對方看不到）",
    "reason_ph": "例如：印表機一直顯示離線",
    "reason_assist": "求助碼 {{code}}",
    "reason_assist_note": "求助碼 {{code}}：{{note}}",
    "form_note": "按下後會請你用 passkey 確認身分，接著開啟這台電腦上的遠端工具。",
    "start_btn": "用 passkey 確認並發起",
    "passkey_canceled": "passkey 確認取消了，還沒有發起。",
    "auth_waiting": "請依瀏覽器的提示用 passkey 確認身分…",
    "tool_first": "這台電腦第一次用遠端協助？",
    "tool_first_body": "對方的畫面會在「遠端工具」視窗裡，先下載安裝；已經裝好就直接發起。",
    "tool_missing": "沒有跳出遠端工具？",
    "tool_missing_body": "這台電腦可能還沒裝。下載安裝後回到這一頁，會自動再開一次（2 分鐘內）；超過時間請取消後再發起一次。",
    "dl": {
      "windows": "下載遠端工具（Windows）",
      "macos": "下載遠端工具（macOS）",
      "linux": "下載遠端工具（Linux）"
    },
    "dl_none": "這個環境沒有設定遠端工具的下載位置，請找系統管理員。",
    "relaunch": "開啟遠端工具",
    "tool_installed": "已經裝好了",
    "tool_open": "遠端工具已開啟；對方允許後就會看到畫面。",
    "tool_opening": "正在開啟遠端工具…沒反應的話按",
    "waiting": "等待{{name}}允許（{{time}}）",
    "waiting_over": "{{name}}還沒有回應，正在確認…",
    "waiting_body": "{{name}}的電腦上跳出允許視窗；只有對方本人能按。可以打電話請對方按〔允許〕。",
    "cancel_session": "取消這次協助",
    "connected": "已連上 {{host}}",
    "connected_body": "對方的畫面在遠端工具視窗裡。{{name}}的螢幕一直有紅框與浮動列，隨時可以結束或收回權限。",
    "slow": "連線較慢",
    "upgrade_waiting": "等待{{name}}允許{{what}}（{{time}}）",
    "upgrade_input_off": "等待期間你的滑鼠與鍵盤暫停。",
    "extend_what": "延長 {{n}} 分鐘",
    "col_perms": "權限",
    "col_until": "時間",
    "until": "到 {{time}} 自動結束（還有 {{n}} 分鐘）",
    "col_recording": "錄影",
    "tip_uac": "對方畫面出現系統權限視窗時你看不到，請對方自己按。",
    "tip_cad": "不能送 Ctrl+Alt+Del（系統安全畫面）。",
    "add_title": "要加的權限",
    "add_note": "會在{{name}}的電腦上再跳一次允許視窗；對方沒按就維持現在的權限。要先用 passkey 確認身分。",
    "add_send": "用 passkey 確認並送出",
    "add_btn": "加權限…",
    "extend_btn": "延長 {{n}} 分鐘",
    "end_btn": "結束協助",
    "ended_title": "{{host}} 的遠端協助已結束",
    "ended_by": {
      "operator_end": "你結束了這次協助。",
      "user_end": "{{name}}按了結束。",
      "time_limit": "時間到，自動結束。"
    },
    "col_duration": "時長",
    "col_files": "傳過的檔案",
    "no_files": "沒有傳檔案",
    "note": "加一句備註（寫進紀錄）",
    "note_ph": "例如：重設印表機佇列後恢復",
    "external_ticket": "外部工單（選填）",
    "external_ticket_ph": "例如：SR-20481",
    "note_audit": "備註與工單會寫進這次協助的紀錄，組織管理員看得到。",
    "note_saved": "已寫進紀錄。",
    "note_save_close": "存進紀錄並關閉",
    "note_then_close": "加備註後結束",
    "note_shown": "備註：{{note}} · 外部工單：{{ticket}}",
    "done": "完成",
    "done_no_note": "不加備註，關閉",
    "close": "關閉",
    "retry": "再試一次",
    "go_passkey": "去註冊 passkey",
    "go_policy": "去組織安全政策",
    "go_seats": "去改派授權",
    "err_code": "錯誤碼 {{code}}",
    "dur_lt_min": "不到 1 分鐘",
    "dur_h_m": "{{h}} 小時 {{m}} 分鐘",
    "out": {
      "denied": "{{name}}拒絕了這次協助",
      "reported": "{{name}}回報沒有要求協助",
      "timeout": "{{name}}沒有回應",
      "no_user": "這台電腦目前沒有人登入，有人值守協助需要螢幕前的人按允許",
      "locked": "{{name}}的螢幕鎖定中，請對方先解鎖",
      "reported_recently": "這台電腦 24 小時內有人按過「我沒有要求協助」",
      "region": "這台電腦在中國大陸，不能遠端協助",
      "allowance": "這台電腦的設定不允許遠端協助",
      "org_policy": "組織的安全政策沒有開遠端協助",
      "paused": "遠端協助已暫停",
      "global_stop": "Kinio 已暫停所有遠端協助",
      "unsupported_desktop": "這台電腦的桌面還不支援遠端協助",
      "role": "你沒有這台電腦的遠端協助權限",
      "forbidden": "你沒有這台電腦的遠端協助權限",
      "busy": "這台電腦已經有進行中的遠端協助",
      "offline": "這台電腦目前離線",
      "unlicensed": "這台電腦未授權，不能遠端協助",
      "taken": "這個請求已經有人接手了",
      "assist_expired": "這個協助請求已經過期",
      "need_passkey": "要先有 passkey 才能遠端協助",
      "receipt": "身分確認沒有通過",
      "too_many": "你同時進行的遠端協助太多了",
      "no_answer": "這台電腦沒有回應",
      "connect_failed": "{{name}}允許了，但沒有接上",
      "connection_lost": "連線中斷，協助已結束",
      "expired": "這次發起已經過期",
      "revoked": "你的遠端協助權限被收回，協助已結束",
      "kill_switch": "組織停止了遠端協助，協助已結束",
      "error": "沒有開始",
      "unlock_timeout": "{{name}}一直沒有解鎖螢幕"
    },
    "out_next": {
      "denied": "可以加一句備註寫進紀錄；需要的話先打電話跟對方確認，再發起一次。",
      "reported": "已通知「{{org}}」的管理員；這台 24 小時內不能再由你發起。",
      "timeout": "60 秒內沒有按〔允許〕算拒絕。可以先打電話請對方準備好，再試一次。",
      "no_user": "請對方登入後按系統匣〔請求遠端協助〕，請求會出現在「協助請求」。",
      "locked": "對方解鎖後按〔再試一次〕。",
      "reported_recently": "這段期間只能由對方自己在系統匣按〔請求遠端協助〕，再從「協助請求」開始。",
      "region": "在中國大陸的電腦不開遠端協助。",
      "allowance": "要由組織擁有者或管理員放寬這台電腦的允許範圍。",
      "org_policy": "組織擁有者或管理員可以在「組織設定 › IT 監控 › 安全政策」打開。",
      "paused": "這台電腦的使用者或組織暫停了自動處置與遠端協助；恢復後再試。",
      "global_stop": "監控、事故與通知照常；恢復由 Kinio 操作。",
      "unsupported_desktop": "Linux 目前只支援 X11 桌面。",
      "role": "請組織管理員給你「遠端協助（有人在場）」的權限。",
      "forbidden": "請組織管理員給你「遠端協助（有人在場）」的權限。",
      "busy": "等那一次結束再發起；如果是你自己的，到「遠端協助 › 紀錄」按〔回到協助〕。",
      "offline": "等它上線再試一次。",
      "unlicensed": "到主機頁的「未授權」改派授權後再發起。",
      "taken": "同一個請求只會由一個人協助。",
      "assist_expired": "請求 30 分鐘就失效；請對方在系統匣再請求一次。",
      "need_passkey": "遠端協助每次都要用 passkey 確認身分（驗證碼不算）。到「我的帳號 › 安全性」註冊。",
      "receipt": "可能是確認逾時或電腦時間不準，請再試一次。",
      "too_many": "同一個人最多同時 3 個，先結束其他的。",
      "no_answer": "可能剛好斷線，稍後再試一次。",
      "connect_failed": "遠端工具 60 秒內沒有連上。確認遠端工具已開啟後再試一次。",
      "connection_lost": "對方電腦斷線超過 30 秒。可以再試一次。",
      "expired": "建立後 5 分鐘內沒有完成身分確認，請再試一次。",
      "revoked": "",
      "kill_switch": "",
      "error": "請再試一次。",
      "unlock_timeout": "請對方解鎖後按〔再試一次〕，或請對方按系統匣〔請求遠端協助〕。"
    },
    "state": {
      "requested": "準備中",
      "awaiting_consent": "等待對方允許",
      "active": "進行中",
      "upgrade_pending": "進行中（等待加權限）"
    },
    "end": {
      "denied": "對方拒絕",
      "reported": "對方回報沒有要求協助",
      "timeout": "對方沒有回應",
      "operator_end": "已結束",
      "user_end": "對方結束",
      "revoked": "權限收回",
      "time_limit": "時間到",
      "kill_switch": "組織停止",
      "rejected": "沒有開始（這台當時不能遠端協助）",
      "expired": "沒有完成身分確認",
      "connect_failed": "沒有接上",
      "connection_lost": "連線中斷",
      "unknown": "已結束"
    },
    "unreadable": "讀不到主機清單",
    "no_hosts": "範圍內還沒有電腦",
    "no_hosts_body": "電腦報到後就可以在這裡協助。",
    "forbidden": "你沒有遠端協助的權限",
    "forbidden_body": "要有「遠端協助（有人在場）」的權限才看得到協助請求；「紀錄」分頁看得到你自己發起的協助。請找組織管理員。",
    "assist_partial": "{{n}} 個組織的協助請求讀不到",
    "assist_title": "{{who}} 請求協助",
    "assist_code": "求助碼 {{code}}",
    "assist_age": "{{time}} 送出",
    "assist_left": "{{n}} 分鐘後失效",
    "assist_taken": "{{name}}已接手",
    "assist_start": "開始協助",
    "assist_note": "請在電話裡跟對方核對求助碼，確認是同一台電腦；開始後對方仍要按〔允許〕。",
    "assist_none": "目前沒有協助請求",
    "assist_none_body": "員工在電腦的系統匣按〔請求遠端協助〕，這裡就會出現；有權限的人也會收到通知。",
    "other_member": "其他成員",
    "range_from": "從",
    "range_to": "到",
    "export_csv": "匯出 CSV",
    "csv": {
      "start": "開始",
      "end": "結束",
      "minutes": "時長（分鐘）",
      "operator": "操作者",
      "org": "組織",
      "home": "$t(translation:leaf.cur)",
      "host": "主機",
      "permissions": "權限",
      "result": "結果",
      "reason": "理由",
      "note": "備註",
      "external_ticket": "外部工單"
    },
    "records_unreadable": "讀不到遠端協助紀錄",
    "col_start": "開始",
    "col_host": "主機",
    "col_operator": "操作者",
    "col_result": "結果",
    "col_note": "備註 / 外部工單",
    "resume": "回到協助",
    "resume_host": "回到遠端協助",
    "ticket_short": "工單 {{ticket}}",
    "records_note": "時長從對方按〔允許〕算到結束；遠端協助一律不錄影。",
    "records_none": "這段期間沒有遠端協助",
    "records_none_body": "換一段期間看看。",
    "host_btn": "遠端協助",
    "block": {
      "unlicensed": "未授權的電腦不能遠端協助",
      "inactive": "這台已停用",
      "offline": "這台目前離線",
      "region": "在中國大陸，不能遠端協助",
      "allowance": "這台的設定不允許遠端協助",
      "local_paused": "使用者在這台暫停了遠端協助",
      "phone": "請在電腦上開始遠端協助"
    },
    "wait_unlock": "{{name}}的螢幕鎖定中",
    "wait_unlock_body": "對方解鎖後會自動再跳出允許視窗，不用重新發起；最晚等到 {{time}}。可以打電話請對方先解鎖。",
    "sent_to_console": "這台電腦還有 {{n}} 個其他登入的工作階段；允許視窗送到螢幕前（主控台）的{{name}}。",
    "records_access_partial": "有些$t(translation:leaf.cur)你只看得到自己發起的紀錄（沒有那些$t(translation:leaf.cur)的遠端協助權限，也不是組織擁有者或管理員）。",
    "records_access_own": "只顯示你自己發起的紀錄：你沒有這個範圍的遠端協助權限，也不是組織擁有者或管理員。"
  },
  "review": {
    "go": "看待確認的電腦",
    "title": "等你確認（{{n}}）",
    "intro": "主機名稱不在預期清單、或跟已報到的電腦同名的電腦先停在這裡：你接受前不會拿到身分，也不佔權杖台數與席次。它們每 15 分鐘會再送一次報到。",
    "selected": "已選 {{n}} 台",
    "select_hint": "勾選後可以一起處理",
    "select_all": "全選待確認的電腦",
    "select_one": "選 {{host}}",
    "reject_btn": "拒絕…",
    "accept_btn": "接受…",
    "col_reason": "為什麼要確認",
    "col_seen": "出現時間",
    "col_actions": "處理",
    "no_hostname": "（沒有回報主機名稱）",
    "reason_not_listed": "不在預期清單",
    "reason_duplicate_name": "跟已報到的電腦同名",
    "first": "第一次 {{time}}",
    "last": "最後一次 {{time}}",
    "inactive": "這把權杖已經不能用了，這些電腦不能再接受；要加入請建新權杖。",
    "none_pending": "沒有等你確認的電腦。",
    "done_title": "已處理（{{n}}）",
    "state_pending": "待確認",
    "state_accepted": "已接受",
    "state_rejected": "已拒絕",
    "state_expired": "權杖失效，未處理",
    "accept_title": "接受 {{n}} 台電腦",
    "accept_body": "{{list}}：接受後會拿到身分、綁進這把權杖的$t(translation:leaf.cur)、用掉 {{n}} 台權杖額度與席次（沒有空席時先是未授權）· 約 15 分鐘內完成報到。接受前會再確認一次你的身分。",
    "accept": "接受",
    "reject_title": "拒絕 {{n}} 台電腦",
    "reject_body": "{{list}}：之後用這把權杖報到都會被拒（改主機名稱也一樣）；要再加入請重建權杖。",
    "reject": "拒絕",
    "partial": "處理了 {{ok}} 台；這些沒處理：{{bad}}",
    "accepted_n": "已接受 {{n}} 台，約 15 分鐘內會完成報到。",
    "rejected_n": "已拒絕 {{n}} 台。",
    "err_done": "已經處理過或不在這把權杖"
  },
  "tpl": {
    "intro": "把門檻、探針、自動處置規則、通知與維護 / 營業時段存成範本，一次套到多個$t(translation:leaf.cur)。範本出新版不會自動下發，要再套用。",
    "show_archived": "顯示已封存",
    "new": "新增範本",
    "new_title": "新增監控範本",
    "empty_title": "還沒有監控範本",
    "empty_body": "建一份範本，之後在「套用」選$t(translation:leaf.cur)、看差異再套。",
    "col_name": "名稱",
    "col_items": "內容",
    "col_version": "版本",
    "col_updated": "最後修改",
    "col_started": "開始時間",
    "col_state": "狀態",
    "col_result": "結果",
    "col_home": "$t(translation:leaf.cur)",
    "archived": "已封存",
    "archived_note": "這份範本已封存：不能再套用，套過的$t(translation:leaf.cur)照舊顯示來源。",
    "new_hosts_note": "新加入的電腦不會自動補上範本的探針與規則，要再套用一次。",
    "unavailable": "讀不到監控範本",
    "applied_homes": "已套用 {{n}} 個$t(translation:leaf.cur)",
    "tabs": "範本分頁",
    "tab_content": "內容",
    "tab_apply": "套用",
    "tab_jobs": "套用紀錄",
    "item_severity_overrides": "門檻與等級",
    "item_maintenance": "維護時段",
    "item_business_hours": "營業時段",
    "item_notify": "通知",
    "item_probes": "探針",
    "item_auto_rules": "自動處置規則",
    "item_hint_severity_overrides": "有勾 = 範本管全部條件與數字（沒改的照預設）。",
    "item_hint_maintenance": "每週重複的維護時段；一次性的維護不進範本。",
    "item_hint_business_hours": "營業時段外，攝影機與工作站的離線降一級。",
    "item_hint_notify": "只帶輪值表；客戶聯絡人屬於客戶，範本不會改。",
    "item_hint_probes": "以「對象類別」描述，套用時對到各$t(translation:leaf.cur)已有的主機、網路設備或收集器；不能寫固定 IP。",
    "item_hint_auto_rules": "套到別的組織的$t(translation:leaf.cur)時，規則要客戶的擁有者 / 管理員用 passkey 簽章才會生效。",
    "item_off": "範本不管這一項（$t(translation:leaf.cur)照自己的設定）。",
    "name": "名稱",
    "description": "說明（選填）",
    "not_included": "範本不含帳密、佈署權杖、允許範圍政策與客戶聯絡人。",
    "pick_schedule": "選一份輪值表",
    "notify_hint": "要是本組織的輪值表；套用到客戶$t(translation:leaf.cur)後，事故會送給這份輪值表的值班者。",
    "probe_name": "名稱",
    "key": "代號",
    "probe_match": "對象",
    "probe_kind": "檢查",
    "match_servers": "伺服器",
    "match_critical": "關鍵主機",
    "match_workstations": "工作站",
    "match_all_hosts": "全部主機",
    "match_network_devices": "全部網路設備（已有 SNMP 的）",
    "match_collector_self": "收集器本機",
    "kind_ping": "Ping",
    "kind_tcp": "TCP 連接埠",
    "kind_http": "HTTP(S)",
    "kind_file": "檔案新鮮度",
    "port": "埠",
    "http_path": "路徑",
    "file_path": "檔案路徑",
    "interval": "多久檢查一次",
    "seconds": "{{n}} 秒",
    "add_probe": "加一條探針",
    "probe_note": "代號是範本內的穩定識別，改版時同一個代號視為同一條。",
    "rule_service": "服務名稱",
    "rule_hosts": "主機",
    "rule_checks": "連續幾次失敗",
    "add_rule": "加一條規則",
    "rule_note": "服務停了自動重啟一次；對到超過 3 台的$t(translation:leaf.cur)不建（改成請人處理）。",
    "err_name": "要填名稱",
    "err_empty": "至少要有一項",
    "err_maint_empty": "維護時段至少一段",
    "err_schedule": "要選輪值表",
    "err_key": "代號只能用小寫英數、_ 或 -",
    "err_key_dup": "代號重複",
    "err_port": "TCP 要填埠",
    "err_http_path": "HTTP 路徑要以 / 開頭",
    "err_file": "檔案新鮮度只能檢查收集器本機，要填路徑",
    "err_service": "要填服務名稱",
    "save": "儲存",
    "create": "建立範本",
    "save_note": "內容改了會變成新版本；已套用的$t(translation:leaf.cur)不會自動更新。",
    "saved": "已儲存。",
    "saved_version": "已存成 v{{v}}。要套到$t(translation:leaf.cur)請到「套用」。",
    "conflict": "別人剛改過這份範本，請重新整理後再改。",
    "archive": "封存",
    "archive_confirm": "封存後不能再套用；套過的$t(translation:leaf.cur)不受影響。確定封存？",
    "pick_intro": "選要套用 v{{v}} 的$t(translation:leaf.cur)（你要對每個$t(translation:leaf.cur)有「設定」權限，經委派也可以），下一步先看差異。",
    "pick_filter": "搜尋$t(translation:leaf.cur)",
    "pick_all": "全選（{{n}}）",
    "pick_none": "清除",
    "picked": "已選 {{n}} 個$t(translation:leaf.cur)",
    "preview_note": "預覽不會改任何設定；200 個$t(translation:leaf.cur)一批。",
    "preview": "預覽差異（{{n}}）",
    "diff_summary": "{{homes}} 個$t(translation:leaf.cur)、{{changes}} 項會變；涉及 {{orgs}} 個客戶組織，套用後各收到 1 則通知。",
    "show_same": "顯示沒變的項目",
    "pending_rules": "{{n}} 條自動處置規則會等「{{org}}」用 passkey 簽章，簽章前不會執行。",
    "n_homes": "{{n}} 個$t(translation:leaf.cur)",
    "n_changes": "{{n}} 項會變",
    "customer_field": "客戶的設定（{{v}}），範本不會改",
    "skip_no_target": "這個$t(translation:leaf.cur)沒有對得到的對象，這條不建",
    "skip_too_many_targets": "對到超過 3 台，這條不自動建（請人處理）",
    "ov_by": "{{org}}改的（{{name}} {{date}}）",
    "fate_keep": "預設保留",
    "fate_overwrite": "會被蓋掉",
    "overwrite_anyway": "仍要蓋掉",
    "pending_rule_row": "套用後待客戶簽章",
    "skipped_title": "跳過 {{n}} 個$t(translation:leaf.cur)",
    "reason_no_permission": "你對這個$t(translation:leaf.cur)沒有設定權限",
    "reason_not_enabled": "這個$t(translation:leaf.cur)還沒啟用 IT 監控",
    "reason_no_target": "範本的探針與規則在這個$t(translation:leaf.cur)都對不到對象",
    "reason_cancelled": "已中斷，沒有套用",
    "reason_error": "暫時套不上（已重試 3 次）",
    "reason_feature_disabled": "這個環境沒開自動處置",
    "reason_rule": "自動處置規則寫不進去（{{detail}}）",
    "back_pick": "重新選$t(translation:leaf.cur)",
    "apply_note": "套用會改到客戶$t(translation:leaf.cur)的設定，要重新驗證身分。",
    "apply": "套用到 {{n}} 個$t(translation:leaf.cur)",
    "apply_confirm": "確定套用到 {{n}} 個$t(translation:leaf.cur)？會通知 {{orgs}} 個客戶組織；客戶改過的項目照上面的勾選處理。",
    "apply_ok": "確定套用",
    "preview_expired": "預覽已過期（10 分鐘），請重新預覽。",
    "jobs_empty": "還沒套用過",
    "job_queued": "排隊中",
    "job_running": "套用中",
    "job_done": "已完成",
    "job_cancelled": "已中斷",
    "job_counts": "已套用 {{applied}}、跳過 {{skipped}}、失敗 {{failed}}（共 {{total}}）",
    "job_progress": "{{done}} / {{total}}",
    "cancelling": "中斷中：跑完目前這一戶就停",
    "notified": "已通知 {{n}} 個客戶組織",
    "cancel": "中斷",
    "retry": "重試失敗的 {{n}} 個$t(translation:leaf.cur)",
    "result_pending": "等待中",
    "result_applied": "已套用",
    "result_skipped": "跳過",
    "result_failed": "失敗",
    "home_result": "改了 {{changed}} 項、保留 {{kept}} 項",
    "home_pending": "{{n}} 條規則待客戶簽章",
    "changed_since_preview": "預覽後客戶又改過，已照當下重算",
    "num_disk_pct": "磁碟快滿",
    "num_tls_days": "TLS 到期天數",
    "num_workstation_offline_days": "工作站離線天數",
    "key_schedule": "輪值表",
    "key_customer_contact": "客戶聯絡人",
    "v_none": "沒有",
    "v_owner_default": "$t(translation:leaf.cur)擁有者（預設）",
    "v_days": "{{n}} 天",
    "v_collector_local": "收集器本機",
    "v_probes": "{{n}} 支（{{targets}}）",
    "v_rule": "{{service}} 停了重啟 · 連續 {{checks}} 次 · {{n}} 台",
    "home_using": "沿用「{{org}}」的監控範本「{{name}}」v{{v}}",
    "home_overrides": "{{n}} 項在這裡改過",
    "home_archived": "「{{name}}」已封存",
    "home_newer": "「{{name}}」有新版 v{{v}}",
    "show_diff": "看差異",
    "hide_diff": "收起",
    "apply_to_others": "套用到其他$t(translation:leaf.cur)…",
    "from_home_name": "{{home}}的設定",
    "from_home_title": "用「{{home}}」目前的設定建範本",
    "from_home_note": "已帶入「{{home}}」目前的門檻與等級、維護時段、營業時段與通知輪值表。探針與自動處置是這個$t(translation:leaf.cur)自己的對象，要的話用對象類別在下面加。存檔後直接選要套用的$t(translation:leaf.cur)。",
    "from_home_skip_notify": "通知用的輪值表不是這個組織的，沒有帶入。",
    "from_home_failed": "讀不到這個$t(translation:leaf.cur)目前的設定，請自己勾選要管的項目。",
    "pick_from_home": "設定來源「{{home}}」不在清單裡。",
    "item_power": "用電提醒（PoE 供電門檻）",
    "power_warn": "注意",
    "power_high": "異常",
    "power_hint": "PoE 已配置或實耗占 Station / 交換器額定的比例（50–100%）。套用後寫進各$t(translation:leaf.cur)的用電設定，那裡標「由範本管理」。",
    "power_err": "門檻要在 50–100，注意不能高於異常",
    "val_power": "PoE 注意 {{warn}}% · 異常 {{high}}%",
    "item_hint_power": "PoE 已配置或實耗占 Station / 交換器額定的比例（50–100%）。套用後寫進各$t(translation:leaf.cur)的用電設定，那裡標「由範本管理」。"
  },
  "install": {
    "title": "安裝參數",
    "tab_windows": "Windows",
    "tab_gpo": "GPO 啟動指令碼",
    "tab_intune": "Intune",
    "tab_linux": "Linux",
    "tab_rmm": "RMM",
    "note_windows": "以系統管理員執行；靜默安裝後會自動報到。",
    "note_gpo": "電腦設定 › Windows 設定 › 指令碼 › 啟動。把指令碼與安裝檔放在只有網域電腦帳號讀得到的共用資料夾：網域使用者讀得到，等於把權杖交給所有網域使用者；建議改用 Intune。",
    "note_intune": "Win32 應用程式的安裝命令；安裝行為選「系統」。權杖只有 Intune 管理員看得到。",
    "note_linux": "安裝套件後執行；權杖從標準輸入讀，不留在指令列。",
    "note_rmm": "RMM 工具的安裝變數（放在只有管理員看得到的機密欄位）。",
    "gpo_download": "下載 GPO 啟動指令碼"
  },
  "built": {
    "new_title": "替客戶建立組織",
    "new_body": "代建的組織由你暫時擔任擁有者，先把$t(translation:leaf.cur)、輪值表、範本與權杖設好，再邀請客戶接手；不算進你自己最多 5 個組織。「{{org}}」還沒完成接手的代建組織最多 20 個。",
    "name": "客戶的組織名稱",
    "create": "替客戶建立",
    "switched": "已切到「{{name}}」",
    "limit": "還沒完成接手的代建組織最多 {{n}} 個：先讓客戶完成接手再建新的。",
    "unavailable": "讀不到代建的客戶",
    "none": "還沒有代建中的客戶",
    "none_body": "完成接手的組織不會列在這裡，之後的關係看委派。",
    "count": "代建中 {{n}} / {{max}} 個",
    "col_name": "組織",
    "col_builder": "代建者",
    "col_customer": "接手客戶",
    "col_created": "建立",
    "customer_owner": "{{name}}（已交出擁有權）",
    "customer_joined": "{{name}}（已加入）",
    "customer_invited": "已邀請 {{email}}",
    "customer_none": "還沒邀請"
  },
  "handover": {
    "title": "接手",
    "partner_fallback": "安裝商",
    "builder_fallback": "代建者",
    "customer_fallback": "接手客戶",
    "not_built": "這個組織沒有待接手的事",
    "not_built_body": "不是代建的組織，或已經完成接手。",
    "unavailable": "讀不到接手進度",
    "intro_customer": "「{{partner}}」替你建立了「{{org}}」，照下面的順序完成接手",
    "intro_builder": "你在替客戶代建「{{org}}」，照下面的順序把組織交給客戶",
    "remaining": "還差 {{n}} 步",
    "dpa_bar": "客戶還沒接受資料處理協議，電腦裝好也不會開始回報（每 15 分鐘自動重試，不用重裝）。",
    "dpa_builder": "資料處理協議要由客戶接受：你可以先做其他步驟。客戶接受前，電腦裝好也不會開始回報。",
    "empty_keyset": "目前沒有人能放寬這個組織電腦的設定：請在任一台電腦由本機管理員確認，或建新權杖重跑安裝。",
    "invite_title": "邀請客戶",
    "invite_body": "客戶用同一個品牌的帳號加入後，就能照這一頁接手；還沒有帳號的人會收到註冊連結。",
    "invite_email": "客戶的電子郵件",
    "invite_btn": "邀請客戶",
    "invite_again": "改寄給這個地址",
    "invite_pending": "已邀請 {{email}}（{{until}} 前有效）",
    "invited": "已邀請 {{email}}",
    "step_owner": "把擁有權交給「{{customer}}」",
    "step_dpa": "接受資料處理協議",
    "step_delegation": "委派給「{{partner}}」",
    "step_template": "監控範本",
    "step_customer_key": "把「{{customer}}」的金鑰加進電腦的管理員清單",
    "step_builder_key": "移除「{{builder}}」的金鑰",
    "step_builder_left": "「{{builder}}」完成接手並退出",
    "state_done": "完成",
    "state_skipped": "略過",
    "state_todo": "現在這一步",
    "state_waiting": "等前面的步驟",
    "why_owner": "交出後「{{builder}}」改成組織管理員，直到退出。",
    "why_dpa": "只有客戶能接受；接受後電腦才開始回報。",
    "why_delegation": "建議範圍「看 + 設定與單次處置」、12 個月；略過的話，接手後「{{partner}}」看不到、也不能幫你處理。",
    "why_template": "代建期間套用的範本：保留，或改回預設（刪掉範本帶進來的探針與還沒執行過的規則）。",
    "why_customer_key": "加了之後，你才能放寬電腦的設定；由「{{builder}}」用他的金鑰簽。",
    "why_builder_key": "移除後「{{builder}}」建的權杖會失效，之後由「{{partner}}」經委派重建。",
    "why_builder_left": "退出後代建關係結束，之後只看委派。",
    "wait_builder": "等「{{builder}}」",
    "wait_customer": "等「{{customer}}」",
    "owner_btn": "把擁有權交給「{{customer}}」",
    "owner_need_customer": "先邀請客戶加入",
    "owner_confirm_title": "把「{{org}}」的擁有權交給「{{customer}}」",
    "owner_confirm_body": "交出後你改成組織管理員；接下來由「{{customer}}」接受資料處理協議。",
    "dpa_btn": "看協議並接受",
    "deleg_btn": "委派給「{{partner}}」…",
    "skip_btn": "略過",
    "skip_title": "略過委派",
    "skip_body": "略過的話，接手後「{{partner}}」看不到、也不能幫你處理；之後隨時可以在「外部組織」委派。",
    "tpl_keep": "保留",
    "tpl_row": "{{home}}：{{name}} v{{v}}",
    "revert_btn": "改回預設",
    "revert_title": "改回預設",
    "revert_body": "{{n}} 個$t(translation:leaf.cur)的範本項目會拿掉：範本帶進來的探針與還沒執行過的規則刪除，門檻與通知保留目前的值。",
    "sign_btn": "簽「新增「{{customer}}」的公鑰」",
    "no_candidate": "「{{customer}}」還沒註冊簽章 passkey，請他先註冊。",
    "request_body": "請先在「管理員 passkey」註冊你的簽章 passkey，再請「{{builder}}」把它加進電腦的管理員清單。",
    "request_btn": "請「{{builder}}」加入你的金鑰",
    "request_sent_at": "{{time}} 已通知「{{builder}}」",
    "register_key": "註冊我的簽章 passkey",
    "sign_sent": "已通知「{{builder}}」",
    "sign_wait": "剛通知過，{{time}} 之後可以再通知一次",
    "remove_btn": "移除我的金鑰",
    "remove_confirm_title": "移除你的金鑰",
    "remove_confirm_body": "你建的 {{n}} 把權杖會失效；失效後由「{{partner}}」經委派重建，新權杖不經過你。已報到的電腦不受影響。",
    "tokens_title": "「{{builder}}」建的權杖（{{n}} 把）會失效",
    "token_row": "{{name}} · 到 {{until}} · 還有 {{n}} 台沒報到",
    "tokens_note": "失效後由「{{partner}}」經委派重建，新權杖不經過你；你不用把權杖傳給任何人。",
    "tokens_ack": "知道了",
    "revoke_btn": "現在撤銷",
    "revoke_title": "撤銷 {{n}} 把權杖",
    "revoke_body": "還沒報到的電腦會報到失敗，要等「{{partner}}」重建權杖、換掉安裝設定。",
    "leave_btn": "完成接手並退出",
    "leave_title": "退出「{{org}}」",
    "leave_body": "退出後你在「{{org}}」的權限全部收回，你建的其餘權杖撤銷；之後「{{partner}}」只能經委派處理。",
    "incomplete_owner_not_transferred": "還沒把擁有權交給接手客戶。",
    "incomplete_customer_key_missing": "「{{customer}}」的金鑰還沒加進電腦的管理員清單。",
    "incomplete_builder_key_present": "你的金鑰還在電腦的管理員清單上，先移除。",
    "conflict_handover_invite_exists": "已經邀請了接手客戶；要換人請先撤回邀請或移出那位成員。",
    "conflict_not_built_org": "這個組織不是代建中的組織。",
    "conflict_already_added": "你的金鑰已經在清單上。",
    "conflict_no_candidate": "你還沒註冊簽章 passkey，先到「管理員 passkey」註冊。",
    "not_handover_customer": "代建的組織只能把擁有權交給接手客戶。",
    "banner_customer": "「{{partner}}」替你建立了這個組織",
    "banner_builder": "你在替客戶代建「{{org}}」",
    "banner_steps": "，還差 {{n}} 步完成接手",
    "banner_continue": "繼續"
  },
  "market": {
    "title": "目前未在您的地區提供",
    "agent_body": "依您目前連線的地區，{{agent}}暫不提供下載與安裝。",
    "tool_body": "依您目前連線的地區，遠端工具暫不提供下載。"
  },
  "power": {
    "phase_outage": "停電中（用電池）",
    "phase_waiting": "市電已恢復，還有 {{n}} 台沒回來",
    "phase_restored": "已恢復",
    "runtime_big": "剩約 {{n}} 分鐘",
    "runtime_unk": "剩餘時間讀不到",
    "runout": "約 {{time}} 用完",
    "battery_pct": "電量 {{pct}}%",
    "load_pct": "負載 {{pct}}%",
    "chart_title": "電池電量 · {{time}} 起",
    "chart_none": "最近 30 分鐘的電量讀不到",
    "show_numbers": "看數字",
    "col_time": "時間",
    "downstream_line": "接在這台 UPS 後面：{{n}} 台（已離線 {{off}} 台）",
    "downstream_line_ok": "接在這台 UPS 後面：{{n}} 台",
    "no_downstream": "不知道哪些設備接在 UPS 後面",
    "no_downstream_rec": "錄影：不知道錄影設備有沒有接在 UPS 後面",
    "register": "登記下游",
    "offline_title": "還沒回來的設備",
    "skip": "不用等這台",
    "skip_aria": "不用等這台：{{name}}",
    "skip_done": "已不再等 {{name}}",
    "escalate_note": "市電恢復 30 分鐘後還有沒回來的，會照輪值表升級",
    "events_title": "轉電池紀錄",
    "event_line": "{{from}}–{{to}}（{{min}} 分鐘）",
    "event_ongoing": "{{from}} 起，還在用電池",
    "escalated": "升級過",
    "live_15": "UPS 剩不到 15 分鐘",
    "live_5": "UPS 剩不到 5 分鐘",
    "impact_title": "停電影響",
    "row_line": "UPS 剩約 {{n}} 分鐘（負載 {{load}}%）",
    "row_line_noload": "UPS 剩約 {{n}} 分鐘",
    "row_line_unk": "UPS 剩餘時間讀不到",
    "col_name": "名稱",
    "col_state": "狀態",
    "col_battery": "電量",
    "col_runtime": "剩餘時間",
    "col_load": "負載",
    "col_downstream": "下游",
    "st_normal": "市電",
    "st_battery": "用電池 {{n}} 分鐘",
    "st_bypass": "旁路",
    "st_none": "輸出已斷",
    "st_other": "其他",
    "st_selftest": "自我測試中",
    "st_unreadable": "讀不到（最後 {{time}}）",
    "val_unk": "讀不到",
    "minutes": "{{n}} 分鐘",
    "downstream_n": "{{n}} 台",
    "downstream_none": "還沒登記",
    "todo_hint": "還沒登記哪些設備接在這台 UPS 後面：停電時它們會各自開事故",
    "empty": "這個範圍還沒有 UPS。收集器用 SNMP 讀到 UPS-MIB 或 APC 的 UPS 會自動出現在這裡。",
    "load_err": "讀不到 UPS",
    "detail_back": "回 UPS 清單",
    "metrics": "讀數",
    "input_v": "輸入電壓",
    "output_w": "輸出功率",
    "temp": "電池溫度",
    "test": "自我測試",
    "test_pass": "通過",
    "test_warning": "有警告",
    "test_error": "失敗",
    "test_aborted": "中止",
    "test_in_progress": "進行中",
    "test_none": "沒有紀錄",
    "alarms": "UPS 回報的狀況",
    "alarms_none": "沒有",
    "downstream_title": "接在這台 UPS 後面",
    "outage_open": "停電事故進行中",
    "see_incident": "看事故",
    "dlg_title": "登記接在「{{name}}」後面的設備",
    "dlg_hint": "停電時這些設備的離線會併進同一件停電事故，不會各自開事故。錄影設備（NVR / Station）登記在下游，停電事故才寫得出錄影影響。",
    "dlg_kinio": "Kinio 設備",
    "dlg_hosts": "主機",
    "dlg_net": "網路設備",
    "dlg_search": "找設備",
    "dlg_all_group": "全選「{{group}}」",
    "dlg_save": "儲存（{{n}} 台）",
    "dlg_saved": "已登記 {{n}} 台",
    "dlg_max": "最多 200 個",
    "dlg_cancel": "取消",
    "dlg_none": "這個$t(translation:leaf.cur)沒有可以登記的設備",
    "no_configure": "你沒有這個$t(translation:leaf.cur)的監控設定權限",
    "alarm": {
      "battery_bad": "需要更換電池",
      "on_battery": "用電池中",
      "low_battery": "電量低",
      "depleted_battery": "電池耗盡",
      "temp_bad": "溫度異常",
      "input_bad": "市電輸入異常",
      "output_bad": "輸出異常",
      "output_overload": "輸出過載",
      "on_bypass": "旁路中",
      "bypass_bad": "旁路異常",
      "output_off_as_requested": "輸出已依指令關閉",
      "ups_off_as_requested": "UPS 已依指令關閉",
      "charger_failed": "充電器故障",
      "ups_output_off": "輸出已斷",
      "ups_system_off": "UPS 已關機",
      "fan_failure": "風扇故障",
      "fuse_failure": "保險絲故障",
      "general_fault": "一般故障",
      "diagnostic_test_failed": "自我測試失敗",
      "communications_lost": "UPS 通訊中斷",
      "awaiting_power": "等待市電恢復",
      "shutdown_pending": "即將關機",
      "shutdown_imminent": "馬上關機",
      "test_in_progress": "自我測試中"
    }
  }
}
